import { render, staticRenderFns } from "./LanguagePickerComponent.vue?vue&type=template&id=7dd82a79&scoped=true"
import script from "./LanguagePickerComponent.vue?vue&type=script&lang=js"
export * from "./LanguagePickerComponent.vue?vue&type=script&lang=js"
import style0 from "./LanguagePickerComponent.vue?vue&type=style&index=0&id=7dd82a79&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd82a79",
  null
  
)

export default component.exports